/**
 * N.B. THIS FILE IS GENERATED! Do not update manually. Run:
 *
 * `npm run -s --workspace=packages/fds-tokens syncFdsColors`
 */
import { ColorToken } from './types';

export const FDSColors: Record<ColorToken, string> = {
  black: '#000000',
  blue100: '#e0efff',
  blue200: '#a8d3ff',
  blue400: '#1260fd',
  blue50: '#edf6ff',
  blue500: '#006eda',
  blue600: '#0057ad',
  gray100: '#f2f3f7',
  gray200: '#e9ebf2',
  gray300: '#d6d9e4',
  gray400: '#b4b9cc',
  gray500: '#969eb3',
  gray600: '#666f89',
  gray700: '#344063',
  gray800: '#131e40',
  green100: '#dff8ec',
  green400: '#29c278',
  green600: '#009e52',
  green800: '#134030',
  orange100: '#fff3dd',
  orange200: '#ffda99',
  orange400: '#ff721a',
  orange600: '#cc8200',
  orange800: '#403013',
  red100: '#ffdde7',
  red400: '#e51f58',
  red600: '#c20d42',
  red800: '#320d18',
  white: '#ffffff',
};
